/**
 * Canonical Identity / API role name strings (must match backend AspNetRoles names).
 * Prefer referencing roles via {@link Constants.Roles} in UI code.
 */
export const Roles = Object.freeze({
  Admin: 'Admin',
  LenderAdmin: 'LenderAdmin',
  LoanOfficer: 'LoanOfficer',
  BrokerAdmin: 'BrokerAdmin',
  Broker: 'Broker',
  Processor: 'Processor',
  AccountExecutive: 'AccountExecutive',
  BrokerFullAccessReadOnly: 'BrokerFullAccessReadOnly',
});

/** Application constants; {@link Constants.Roles} is the single source of truth for role strings in the UI. */
export const Constants = Object.freeze({
  Roles,
});

const roleHomeRoutes = {
  [Roles.Admin]: '/lender/brokers',
  [Roles.LenderAdmin]: '/lender/brokers',
  [Roles.LoanOfficer]: '/ae/dashboard',
  [Roles.BrokerAdmin]: '/broker/pipeline',
  [Roles.Broker]: '/broker/pipeline',
  [Roles.Processor]: '/broker/pipeline',
  [Roles.BrokerFullAccessReadOnly]: '/broker/pipeline',
  [Roles.AccountExecutive]: '/ae/dashboard',
};

/**
 * Returns the default home route for a given role.
 * Falls back to /login if the role is unknown.
 */
export const getHomeRoute = (role) => roleHomeRoutes[role] || '/login';
